export class Assert {
  static ok(ok: boolean, message?: string): void {
    if (!ok) {
      throw new Error(message);
    }
  }
}
